import { Injectable } from '@angular/core';
import {ApiUploadRepository} from "./api/upload/api.upload.repository";
import {Files} from "../models/files";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class UploadService {

  HTTP_RESPONSE = environment.HTTP_RESPONSE;

  constructor(private apiUploadRepository: ApiUploadRepository,
              private files: Files,
              private modalService: NgbModal){ }


  public async uploadFileServe(file: FormData): Promise<any> {
    // @ts-ignore
    return await this.apiUploadRepository.uploadFileServe(file);
  }

  public uploadFile(event: any, filesObj: any = {}){

    const file: File = event.files[0];

    if (file) {

      filesObj.isLoading = true;
      const formData = new FormData();

      formData.append("archivo", file as any, file.name);

      this.uploadFileServe(formData).then((response: any) => {
        // @ts-ignore
        if (response.tipo == this.HTTP_RESPONSE.SUCCESS) {
          filesObj.files_url = response.data;
        }

        filesObj.isLoading = false;
      });

    }
  }

  /**
   * Sube un archivo y retorna la URL del archivo subido o null en caso de error
   * @param file - Archivo a subir
   * @returns Promise<string | null> - URL del archivo o null
   */
  public async uploadFileAndGetUrl(file: File): Promise<string | null> {
    try {
      const formData = new FormData();
      formData.append("archivo", file, file.name);

      const response: any = await this.uploadFileServe(formData);

      // @ts-ignore
      if (response.tipo == this.HTTP_RESPONSE.SUCCESS) {
        return response.data; // Retorna la URL del archivo
      }

      return null; // Error en la respuesta
    } catch (error) {
      console.error('Error al subir archivo:', error);
      return null; // Error en la petición
    }
  }

  public async addFile(filesObj: any = {}, filesList: any[] = []){

    filesObj.isLoadingButton = true;

    await this.files.getFileFormat(filesObj).then((response: any) => {
      // @ts-ignore
      if (response.tipo == this.HTTP_RESPONSE.SUCCESS) {
        filesList.push(response.data);
        filesObj = {};
        this.modalService.dismissAll();
        filesObj.isLoadingButton = false;
      }
    });

  }

  validateFileUpload(filesObj: any = {}){
    return filesObj.files_type  && filesObj.files_url;
  }

}
